import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import * as actions from '../actions/notification'
import {
    GET_NOTIFICATION_SETTINGS_REQUEST,
    GET_MENU_NOTIFICATIONS_REQUEST,
    GET_NOTIFICATIONS_REQUEST
} from '../types'
import {API_NOTIFICATION} from '../../helpers/api'

// GET NOTIFICATION SETTINGS
function* watchGetNotificationSettings() {
    yield takeEvery(GET_NOTIFICATION_SETTINGS_REQUEST, getNotificationSettings);
}

function* getNotificationSettings(action) {
    try {
        const res = yield call(apiGetNotificationSettings, action.payload);
        yield put(actions.getNotificationSettingsSucceeded({...res.data}));
    }catch(err) {
        yield put(actions.getNotificationSettingsFailed());
    }
}

const apiGetNotificationSettings = organizationId => (
    API_NOTIFICATION(`notification/settings/${organizationId}`, 'GET')
)

// GET NOTIFICATIONS
function* watchGetMenuNotifications() {
    yield takeEvery(GET_MENU_NOTIFICATIONS_REQUEST, getMenuNotifications);
}

function* getMenuNotifications(action) {
    try {
        const res = yield action.paylaod ? 
            call(apiGetMenuNotifications, action.payload) : 
            call(apiGetNotifications, action.payload, {}, null, 5);
        yield put(actions.getMenuNotificationsSucceeded(action.paylaod ? 
            [...res.data] : [...res.data.items]
        ));
    }catch(err) {
        yield put(actions.getMenuNotificationsFailed());
    }
}

const apiGetMenuNotifications = organizationId => (
    API_NOTIFICATION( 
        `notification/organization/${organizationId}`
    , 'GET', null, {
        count: 5
    })
)

// GET NOTIFICATIONS
function* watchGetNotifications() {
    yield takeEvery(GET_NOTIFICATIONS_REQUEST, getNotifications);
}

function* getNotifications(action) {
    try {
        const {organizationId, sort, page, size} = action.payload;
        const res = yield call(apiGetNotifications, 
            organizationId, sort, page, size
        );
        yield put(actions.getNotificationsSucceeded({
            items: [...res.data.items],
            activePage: res.data.currentPage,
            totalPageCount: Math.ceil(res.data.totalItemCount / size)
        }));
    }catch(err) {
        yield put(actions.getNotificationsFailed());
    }
}

const apiGetNotifications = (organizationId, sort, page, size) => (
    API_NOTIFICATION(organizationId ? 
        `notification/organization/all/${organizationId}` : 
        'notification/admin'
    , 'GET', null , {
        sort,
        page,
        size
    })
)

export default function* notificationSaga() {
    yield all([
        fork(watchGetNotificationSettings),
        fork(watchGetMenuNotifications),
        fork(watchGetNotifications)
    ]);
}